/**
 * True when MSAL's hidden renewal iframe loaded this page with the Entra
 * response in the URL. Since MSAL v5 the main window no longer reads that
 * frame: the page must relay the response through
 * `broadcastResponseToMainFrame`, otherwise every silent renewal waits for
 * `iframeBridgeTimeout` (10 s) and fails with `redirect_bridge_timeout`.
 */
export function isAuthResponseFrame(win: Window): boolean {
  if (win.parent === win) return false;
  return /(^|[#?&])state=/.test(`${win.location.hash}${win.location.search}`);
}
